// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/metar-rvr.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/metar-rvr/metar-rvr.js';

mount([g0]);
